import { ConnectorChannelIcon } from "#components/ui/ConnectorChannelIcon.tsx";
import { ConnectChannel } from "#features/channels/components/channels-details/ConnectChannel.tsx";
import { channelTypeToIntegration } from "#features/conversations/integrations/index.ts";
import { useSharedTranslation } from "#hooks/useSharedTranslation.ts";
import type { ConnectorChannelType } from "#types/types.ts";

interface Props {
    channelType: ConnectorChannelType;
}

export const ConnectPersonalChannel = ({ channelType }: Props) => {
    const { tShared } = useSharedTranslation();
    const manifest = channelTypeToIntegration[channelType];

    if (!manifest) {
        return null;
    }

    return (
        <ConnectChannel
            icon={<ConnectorChannelIcon type={channelType} isPlateless />}
            title={tShared(manifest.nameKey)}
            description={tShared(manifest.descriptionKey)}
        />
    );
};
